import React, {Fragment} from "react";
import {Button, Col, Form, Modal, Row, Input, Switch, Icon} from "antd";
import {FormattedMessage} from "react-intl";
import ImagePicker from '@components/custom/imagePicker';
import GalleryItemPreview from "@components/video-contents/galleries/GalleryPreview";
import {Image} from "@models/image";
import {Gallery} from "@models/gallery";

interface PropsShape {
  item: Gallery | null;
  form: any;
  index: number;
  onEdit: any;
  onAdd: any;
  visible: boolean;
  disabled: boolean;
  image: Image;
  id: string | null;
}

class ItemForm extends React.Component<PropsShape> {
  constructor(props) {
    super(props);
    const {item} = this.props;
    this.state = {
      visible: false,
      title: item && item.title ? item.title : "",
      order: item && item.order ? item.order : this.props.index,
      is_active: item && item.is_active ? item.is_active : false,
      image: item && item.image ? item.image : null,
      image_id: item && item.image ? item.image.id : null,
      video_content_id: item && item.video_content ? item.video_content.id : null,
      id: item && item.id ? item.id : null
    };
  }
  
  handleSubmit = () => {
    this.props.form.setFieldsValue({
      "image_id": this.state.image ? this.state.image.id : ""
    });
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const data = {
          is_active: this.state.is_active,
          order: this.state.order ? this.state.order : this.props.index,
          image: this.state.image ? this.state.image : null,
          id: this.state.id ? this.state.id : null,
          ...values
        };
        
        if (this.props.item) {
          this.props.onEdit(this.props.index, data);
        } else {
          this.props.onAdd(data);
        }
        
        this.setState({
          ...data,
          visible: false
        })
      }
    });
  };
  
  showImagePickerModal = (disabled: boolean) => {
    this.setState({
      visible: true,
      disabled: disabled
    });
  };
  
  hideModal = () => {
    this.setState({
      visible: false
    });
  };
  setImage = (image: Image) => {
    this.setState({
      image: image,
      image_id: image.id
    })
  };
  
  onStatusChange(is_active: boolean) {
    this.setState({
      is_active
    });
  }
  
  visableView() {
    let {item, key, index, id, moveCard, onDelete} = this.props;
    if (!item) {
      return (
        <Button type="link" onClick={() => this.showImagePickerModal(false)}>
          <FormattedMessage id="app.add_item" defaultMessage={`Add Item`}/>
          <Icon type="plus"/>
        </Button>
      );
    } else {
      return (
        <GalleryItemPreview
          key={key}
          id={`${index}`}
          index={index}
          item={item}
          moveCard={moveCard}>
          <Icon type="edit" onClick={(e) => {
            e.preventDefault();
            this.showImagePickerModal(true)
          }}/>
          <Icon type="delete" onClick={() => onDelete(index)}/>
        </GalleryItemPreview>
      )
    }
  }
  
  render() {
    const {form} = this.props;
    const {getFieldDecorator} = form;
    return (
      <Fragment>
        {this.visableView()}
        <Modal
          className="form-modal"
          visible={this.state.visible}
          destroyOnClose={true}
          closable={false}
          maskClosable={false}
          mask={false}
          footer={[
            <Button key="back" onClick={() => this.hideModal()}>
              <FormattedMessage id="app.cancel" defaultMessage={`Cancel`}/>
            </Button>,
            <Button key="submit" type="primary" onClick={() => this.handleSubmit()}>
              <FormattedMessage id="app.save" defaultMessage={`Save`}/>
            </Button>
          ]}>
          
          <div className={'form-wrapper'}>
            <Form>
              <Row gutter={24}>
                <Col span={24}>
                  <Form.Item className={'no-label video-poster-wrapper'}>
                    {getFieldDecorator("image_id", {
                      rules: [{
                        required: true,
                        message: <FormattedMessage id="app.image_is_required"
                                                   defaultMessage={`Image is required!`}/>
                      }]
                    })(
                      <ImagePicker onSelectImage={this.setImage}
                                   selectedImage={this.state.image}
                                   disableImagePicker={this.state.disabled}>
                        <div
                          className={`image-wrapper ${this.state.disabled ? 'disabled-image-picker' : ''}`}
                          style={{backgroundImage: `url(${this.state.image ? this.state.image.path : ""})`}}>
                          <FormattedMessage id="app.select_image"
                                            defaultMessage={`Select image`}/>
                        </div>
                      </ImagePicker>
                    )}
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item label={<FormattedMessage id="app.title" defaultMessage={`Title`}/>}>
                    {getFieldDecorator("title", {
                      initialValue: this.state.title,
                      rules: [{
                        required: true,
                        message: <FormattedMessage id="app.title_is_required"
                                                   defaultMessage={`Title is required!`}/>
                      }]
                    })(<Input/>)}
                  </Form.Item>
                </Col>
  
                <Col span={24}>
                  <Form.Item
                    label={
                      <FormattedMessage id="app.status" defaultMessage={`Status`}/>
                    }>
                    <Switch
                      defaultChecked={this.state.is_active}
                      onChange={this.onStatusChange.bind(this)}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </div>
        </Modal>
      </Fragment>
    );
  }
}

const WrappedGalleryItemPopUp = Form.create({name: "gallery-item-form"})(ItemForm);
export default WrappedGalleryItemPopUp;
